import React, {Component} from 'react';
import Popup from '../popup/popup';
import css from './groupsList.scss';
import {Mutation} from 'react-apollo';
import {CREATE_GROUP, GET_GROUPS} from './queries';
// import css from './groupsList.scss';

class CreateGroup extends Component {
	state = {
		name: '',
	};
	updateName = val => {
		this.setState(_ => ({name: val}));
	};
	updateCache = (cache, {data: {group}}) => {
		const data = cache.readQuery({query: GET_GROUPS});
		data.groups.push(group);
		cache.writeQuery({query: GET_GROUPS, data});
		this.updateName('');
	};
	render() {
		return (
			<Mutation
				mutation={CREATE_GROUP}
				variables={{name: this.state.name}}
				update={this.updateCache}
			>
				{(addGroup, {loading, error}) => (
					<li className={css.item}>
						<span className={css.fake} />
						<form
							// className={css.form + (loading ? ' loading' : '')}
							onSubmit={e => {
								e.preventDefault();
								addGroup();
							}}
						>
							<input
								type="text"
								placeholder="Nom"
								value={this.state.name}
								onChange={e => this.updateName(e.target.value)}
								required
							/>
							{error && (
								<Popup opened>
									{error.graphQLErrors[0]}
								</Popup>
							)}
						</form>
					</li>
				)}
			</Mutation>
		);
	}
}

export default CreateGroup;



// WEBPACK FOOTER //
// ./src/groupsList/createGroup.js